import { Oval } from 'react-loader-spinner';

export default function Loader() {
    return (
        <div className="loader">
            <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
        </div>
    );
}